import { FinTechOpsCategories, POLICY_ENGINE_LAST_UPDATED_AT_S3_PREFIX, POLICY_ENGINE_S3_PREFIX } from '../../FinTechOpsConstants';
import { returnUsefulRawPolicyEngineData } from '../../policy-engine/PolicyEngineDataProcessing';
import { PolicyEngineParsedDetails, PolicyEngineRawData } from '../../policy-engine/PolicyEngineInterface';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const usePolicyEngineData = (): UseS3DatasetResult<PolicyEngineParsedDetails> =>
  useS3Dataset<PolicyEngineRawData[], PolicyEngineParsedDetails>({
    prefix: POLICY_ENGINE_S3_PREFIX,
    lastUpdatedPrefix: POLICY_ENGINE_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.policyEngine,
    parse: returnUsefulRawPolicyEngineData
  });
